import React from 'react';
import { StyleSheet, View } from 'react-native';
import { rem } from 'design-system/values';
import SectionHeader from 'features/invest/components/SectionHeader';
import IconCircle from 'design-system/icons/IconCircle';
import IconTransactionCategory from 'features/transactions/icons/IconTransactionCategory';
import { Spacer } from 'design-system';
import Text from 'design-system/Text';
const ExcludeSubcategoriesList = ({ subcategories }) => (<>
    <SectionHeader title="Subcategories" style={styles.header}/>
    <View style={styles.subcategories}>
      {subcategories.map((subcategory) => (<View key={subcategory.id} style={styles.row}>
          <IconCircle width={24} height={24}>
            <IconTransactionCategory category={subcategory} width={rem(14)} height={rem(14)}/>
          </IconCircle>
          <Spacer.W8 />
          <Text Text-14>{subcategory.displayName}</Text>
        </View>))}
    </View>
  </>);
const styles = StyleSheet.create({
    subcategories: {
        flexDirection: 'row',
        flexWrap: 'wrap',
        gap: rem(16),
        alignItems: 'center',
        paddingHorizontal: rem(16),
        paddingBottom: rem(16),
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    header: {
        marginTop: 0,
    },
});
export default ExcludeSubcategoriesList;
